import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { hideMessage } from "actions";
import Slide from "@material-ui/core/Slide";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import classes from "./SnackBarMessage.module.scss";
const SnackBarMessage = () => {
  const authData = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  function SlideTransition(props) {
    return <Slide {...props} direction="right" />;
  }
  const handleClose = () => {
    dispatch(hideMessage());
  };
  return (
    // <div className={classes.root}>
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      // open={authData.showMessage}
      autoHideDuration={3000000}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      message={authData.alertMessage}
      key={"top" + "left"}
      className={authData.success ? classes.success : classes.danger}
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={handleClose}
        >
          {authData.success ? <CheckCircleIcon /> : <CancelIcon />}
        </IconButton>,
      ]}
    />
    // </div>
  );
};

export default SnackBarMessage;
